import styled from "styled-components";

export const DashboardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #0c0d15;
  position: relative;
`;

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 12px;
  position: absolute;
  right: 40px;
  top: 15px;
  z-index: 1;
`;
